import { render } from "./fiat.vue?vue&type=template&id=efb938b4&scoped=true&ts=true"
import script from "./fiat.vue?vue&type=script&lang=ts"
export * from "./fiat.vue?vue&type=script&lang=ts"

import "./fiat.vue?vue&type=style&index=0&id=efb938b4&lang=less&scoped=true"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb938b4"]])

export default __exports__